import React from "react";
import { Row as BSRow } from "react-bootstrap";
export const Row = (props) => {
    return React.createElement(BSRow, { ...props });
};
